// Content sourced & adapted from devata.org and datasia.us

export const BOOKS = [
  {
    id: "road-of-the-strong",
    title: "The Road of the Strong",
    subtitle: "A Romance of Colonial Cambodia",
    author: "George Groslier",
    year: "2017",
    pages: "402 pp.",
    format: "Hardcover · Illustrated",
    cover:
      "https://www.datasia.us/datasia-data/uploads/2017/11/51Th9jpSD-L._SX346_BO1204203200_.jpg",
    blurb:
      "A sweeping novel of passion and fate set against the temples and jungles of 1920s Cambodia, written by the founder of the National Museum in Phnom Penh. Groslier's only novel, translated into English for the first time.",
    amazon: "https://www.amazon.com/Road-Strong-Romance-Colonial-Cambodia/dp/1934431168/?tag=devorg-20",
  },
  {
    id: "khmer-kings-i",
    title: "The Khmer Kings and the History of Cambodia",
    subtitle: "Book I · 1st Century to 1595 — Funan, Chenla, Angkor & Longvek",
    author: "Kenneth T. So",
    year: "2017",
    pages: "336 pp.",
    format: "Hardcover · Maps & Genealogies",
    cover:
      "https://www.datasia.us/datasia-data/uploads/2017/11/51AfVitR0sL._SX383_BO1204203200_.jpg",
    blurb:
      "The definitive chronicle of Cambodia's earliest kingdoms — from the maritime empire of Funan through the glory of Angkor. A meticulous reconstruction of royal lineages drawn from inscriptions and chronicles.",
    amazon: "https://www.amazon.com/s?k=The+Khmer+Kings+History+of+Cambodia+Book+I+Kenneth+So",
  },
  {
    id: "khmer-kings-ii",
    title: "The Khmer Kings and the History of Cambodia",
    subtitle: "Book II · 1595 to the Contemporary Period",
    author: "Kenneth T. So",
    year: "2017",
    pages: "358 pp.",
    format: "Hardcover · Maps & Genealogies",
    cover:
      "https://www.datasia.us/datasia-data/uploads/2017/11/513D79mFKfL._SX384_BO1204203200_.jpg",
    blurb:
      "The continuation of So's landmark history, tracing Cambodia from the post-Angkorian courts through colonial upheaval and into the modern nation — a story of resilience across four turbulent centuries.",
    amazon: "https://www.amazon.com/s?k=The+Khmer+Kings+History+of+Cambodia+Book+II+Kenneth+So",
  },
  {
    id: "customs-of-cambodia",
    title: "Customs of Cambodia",
    subtitle: "The Record of Zhou Daguan",
    author: "Zhou Daguan · trans. Solang & Beling Uk",
    year: "2016",
    pages: "192 pp.",
    format: "Hardcover · Annotated Edition",
    cover:
      "https://www.datasia.us/datasia-data/uploads/2017/11/61u0KDJeCgL._SX346_BO1204203200_.jpg",
    blurb:
      "The only surviving eyewitness account of Angkor at its zenith, written by a 13th-century Chinese envoy. This fully annotated translation brings the living, breathing Khmer Empire vividly back to life.",
    amazon: "https://www.amazon.com/s?k=Customs+of+Cambodia+Zhou+Daguan",
  },
  {
    id: "cambodia-past",
    title: "Cambodia Past",
    subtitle: "Explaining the Present",
    author: "Étienne F. Aymonier",
    year: "2016",
    pages: "284 pp.",
    format: "Hardcover · Historical Survey",
    cover:
      "https://www.datasia.us/datasia-data/uploads/2017/11/511O1it4KJL._SX341_BO1204203200_.jpg",
    blurb:
      "The pioneering 19th-century survey by the explorer-scholar who first mapped Cambodia's monuments and languages. A foundational text of Khmer studies, newly edited for the modern reader.",
    amazon: "https://www.amazon.com/s?k=Cambodia+Past+Explaining+the+Present+Aymonier",
  },
  {
    id: "king-cobra",
    title: "King Cobra",
    subtitle: "Mekong Adventures in French Indochina",
    author: "Harry Hervey",
    year: "2013",
    pages: "312 pp.",
    format: "Hardcover · Travel Classic",
    cover:
      "https://www.datasia.us/datasia-data/uploads/2016/03/2013-King-Cobra-front-5001-500x440.jpg.webp",
    blurb:
      "A dazzling 1920s travel narrative up the Mekong — opium dens, lost temples, and river pirates. Hervey's lush, cinematic prose captures French Indochina at its most romantic and dangerous.",
    amazon: "https://www.amazon.com/s?k=King+Cobra+Harry+Hervey+Indochina",
  },
];

export const CATEGORIES = [
  "All Writings",
  "Art & Sculpture",
  "Dance & Performance",
  "History",
  "Book Reviews",
  "Research",
];

export const ARTICLES = [
  {
    id: "sappho-marchal",
    title: "The Costumes of the Devata of Angkor Wat",
    author: "Kent Davis",
    date: "September 2013",
    category: "Book Reviews",
    readTime: "9 min read",
    note: "a 23-year-old's quiet revolution",
    tags: ["Sappho Marchal", "Angkor Wat", "Khmer art", "Devata goddesses", "Feminine style", "Book Review"],
    image:
      "https://www.devata.org/dat-devata/uploads/2013/09/Marchal_030-H1-332x231.jpg",
    excerpt:
      "How is it that in 1927 a 23-year-old artist had more insight into the 1,800 devata of Angkor Wat than mainstream scholars would for eighty years?",
    body: [
      "A mystery. How is it that in 1927, a 23-year-old artist had more insight into the diversity of the 1,800 devata goddesses at the Khmer temple of Angkor Wat than mainstream scholars would for the next eighty years?",
      "Equipped with nothing but a pad of paper and a pencil, Sappho Marchal was the first person to begin a quantitative analysis of the symbolism encoded in the royal female portraits immortalized in Angkor Wat. Who were these women? What hierarchy do they represent? Chances are the answers are portrayed in Sappho's clear drawings. Originally published as “Costumes et parures khmèrs d'après les devatâ d'Angkor-Vat,” this long-lost gem of Asian history, art and feminine style is now available in English as “Costumes of the Devata of Angkor Wat.”",
      "“Sappho Marchal's visual meditation on the women of Angkor Wat is a gem to treasure — for the images it holds and the ideas it will inspire.”",
      "While the topic of Khmer adornment occupies a narrow niche of academic knowledge, its exquisite style holds universal appeal as world-class art. Asian art, fashion, history, jewelry, graphic design, feminine style and culture all intersect in her compact 99-page work.",
      "Marchal's book revolves around 41 plates of line-art drawings of the apsara or devata carvings at Angkor Wat. More than 1,800 women were immortalized in sandstone between 1116 and 1150 AD. Some experts call them “celestial nymphs” or demi-goddesses — but these terms were applied long after the fall of the civilization. The truth is that the identity and meaning of the Angkor Wat women remain a mystery.",
      "What is undeniable is the beauty, life and energy the carvings radiate. As Dr. Paul Cravath of the University of Hawaii wrote, “There, with stupendous variety, the Feminine achieved a new level of expression unsurpassed at any time in Asian sculpture.”",
      "Sappho was in a unique position to study Angkor Wat: her father, Henri Marchal, was appointed the second curator of the vast Angkor site for the French colonial government in 1916. She grew up among these extraordinary Khmer women, and highlights details of their hair, costumes and ornamentation that archaeologists — in their rush to measure stones and chart stellar alignments — never paused to notice.",
      "For those interested in Southeast Asian, Thai and Cambodian art this book is indispensable. But the truth is that it is a beautiful book for anyone. — Review by Kent Davis, DatAsia, Inc. & Devata.org",
    ],
  },
  {
    id: "indian-apsaras",
    tags: ["Apsara", "Dance", "Angkor", "India", "Performance"],
    title: "Indian Apsaras Reveal the Untold Story of Angkor Wat",
    author: "Apsaras Arts, Singapore",
    date: "November 2013",
    category: "Dance & Performance",
    readTime: "6 min read",
    note: "royal love & divine wisdom",
    image:
      "https://www.devata.org/dat-devata/uploads/2013/11/ApsarasArts-Priya-at-Angkor-01-332x335.jpg.webp",
    excerpt:
      "A tale of royal love, divine wisdom, treachery and betrayal — the passion of a woman so pure the temple she helped build still stands a millennium later.",
    body: [
      "In a tale that traces royal love, divine wisdom, treachery and betrayal, “Angkor — The Untold Story” depicts the passion of a woman so pure that the temple she helped build nearly a millennium ago still stands as a testament to her devotion.",
      "In this production by the Apsaras Arts dance troupe of Singapore, Indian apsaras reveal the untold story of Angkor Wat in a spectacular performance — a breathtaking homage to the shared art and heritage of Cambodia and India.",
      "The November 2013 Indian Festival of Esplanade showcased their presentation as its opening performance, a rare bridge between two of Asia's great classical traditions.",
    ],
  },
  {
    id: "groslier-dancers",
    tags: ["George Groslier", "Royal Ballet", "1927", "Photography", "Khmer dance"],
    title: "Royal Cambodian Dancers of Sisowath, 1927",
    author: "Photographs by George Groslier",
    date: "1928",
    category: "Dance & Performance",
    readTime: "5 min read",
    note: "prophetic words, 1928",
    image:
      "https://www.devata.org/dat-devata/uploads/2013/09/nou-nam1-332x248.jpg.webp",
    excerpt:
      "“Cambodian royal dances… are seriously threatened due to the very evolution of Cambodia and Western progress.” Prophetic words penned in 1928.",
    body: [
      "“Cambodian royal dances, the admirable artistic tradition and all the indigenous past they represent are seriously threatened due to the very evolution of Cambodia and Western progress.”",
      "These prophetic words could have been written at any time, but they were actually penned in 1928 by George Groslier, founder and director of the National Museum in Phnom Penh.",
      "See dozens of these rare photographs, recently revealed by the National Museum of Cambodia — a vanished world of court dancers caught forever in silver and light.",
    ],
  },
  {
    id: "jean-despujols",
    tags: ["Jean Despujols", "Painting", "French Indochina", "Prix de Rome"],
    title: "Jean Despujols — Prix de Rome Centennial",
    author: "Godefroy Hofer",
    date: "July 2014",
    category: "Art & Sculpture",
    readTime: "7 min read",
    note: "a grandson remembers",
    image:
      "https://www.devata.org/dat-devata/uploads/2014/07/500-Jean-Despujols-self-portrait-devata-org.jpg",
    excerpt:
      "His paintings of Angkor and Cambodian dancers are among the most beautiful ever created. A centennial tribute by the artist's grandson.",
    body: [
      "Born in Salles en Gironde, France on March 19, 1886, Jean Despujols is best known to Southeast Asian scholars for his stunning art depicting French Indochina during his two-year mission throughout the region from 1936 to 1938.",
      "His paintings of Angkor and Cambodian dancers are among the most beautiful ever created.",
      "This article by his grandson, Godefroy Hofer, describes the competition that established his reputation as a world-class artist, and celebrates a magnificent anniversary: Jean Despujols' centennial of winning the Grand Prix de Rome on July 18, 1914.",
    ],
  },
  {
    id: "groslier-school-1",
    tags: ["George Groslier", "Khmer Crafts", "School of Cambodian Arts"],
    title: "George Groslier & the School of Cambodian Arts — Part I",
    author: "Miss H. W. Ponder",
    date: "1936",
    category: "History",
    readTime: "9 min read",
    note: "“The Tree of Knowledge”",
    image:
      "https://www.devata.org/dat-devata/uploads/2013/11/A001-1922-12-05-Groslier-in-study-332x243.jpg.webp",
    excerpt:
      "In 1936, English author Miss H. W. Ponder published Cambodian Glory, with a detailed chapter on Groslier's revival of the classic Khmer crafts.",
    body: [
      "In 1936, English author Miss H. W. Ponder published Cambodian Glory, including a detailed chapter about George Groslier and the School of Cambodian Arts titled “The Tree of Knowledge.”",
      "Excerpts from her article are featured here as a four-part series detailing Groslier's work reviving the classic crafts of the Khmer people by founding the School of Cambodian Arts.",
      "This is the first article in the series — an intimate portrait of a man determined to save a civilization's handwork from disappearing.",
    ],
  },
  {
    id: "groslier-school-2",
    tags: ["Khmer Crafts", "Weaving", "Bronze", "Silver", "Cambodia"],
    title: "Khmer Crafts — The School of Cambodian Arts, Part II",
    author: "Miss H. W. Ponder",
    date: "1936",
    category: "History",
    readTime: "8 min read",
    note: "modelling, bronze & silk",
    image:
      "https://www.devata.org/dat-devata/uploads/2013/12/Khmer-dancer-statue-finot-332x316.jpg.webp",
    excerpt:
      "Modelling, wood-carving, bronze-casting, gold- and silver-smithing, and weaving — the crafts taught at Groslier's remarkable school.",
    body: [
      "In early 20th-century Cambodia, George Groslier established the School of Cambodian Arts, teaching students the crafts of modelling, wood-carving, sculpture, bronze-casting, furniture-making, the art of the goldsmith or silversmith, and — for the girls — weaving.",
      "In 1936, English author Miss H. W. Ponder published Cambodian Glory, including a detailed chapter about this unique school.",
      "This is the second of a four-part series excerpted from her work — a walk through workshops where a thousand-year-old aesthetic was carefully taught, hand to hand.",
    ],
  },
  {
    id: "folktales",
    tags: ["Folktales", "Solang Uk", "Bilingual", "Cambodia", "Literature"],
    title: "Fascinating, Fantastic & Funny Cambodian Folktales",
    author: "Solang Uk",
    date: "October 2013",
    category: "Book Reviews",
    readTime: "6 min read",
    note: "outwit the pirates!",
    image:
      "https://www.devata.org/dat-devata/uploads/2013/10/9781934431214-Womens-Wiles-Cover-Front-72dpi-332x476.jpg",
    excerpt:
      "Cambodian imagination knows no bounds — villagers, kings, angels, and fierce island pirates, in a new bilingual collection.",
    body: [
      "Cambodian imagination knows no bounds! This collection of folktales in English and French takes readers through imaginative twists and turns to meet simple villagers living deep in the jungle, kings and princesses in fabulous palaces, and the angels and gods of the Hindu heavens.",
      "You'll even confront — and outwit — fierce pirates hiding in island lairs.",
      "Originally collected by French writer G. H. Monod in the early 20th century, Cambodian scholar Solang Uk adds new perspectives and cultural context. The rare cover painting of village life was done by George Groslier in 1912.",
    ],
  },
  {
    id: "lucille-douglass",
    tags: ["Lucille Douglass", "Angkor", "American artist", "1927"],
    title: "From America to Angkor — The Odyssey of Lucille Douglass",
    author: "Lucille Douglass",
    date: "1927",
    category: "Art & Sculpture",
    readTime: "5 min read",
    note: "“an inspiration”",
    image:
      "https://www.devata.org/dat-devata/uploads/2010/04/5-Douglass-1927-Angkor-Wat.jpg",
    excerpt:
      "“Angkor is one of the really great experiences of my life.” The American artist who would remain at Angkor for all eternity.",
    body: [
      "In 1927, American artist Lucille Douglass wrote the lines below — who would suspect that she would remain at Angkor Wat for all eternity?",
      "“Angkor is one of the really great experiences of my life — a more intellectual than emotional experience. Not that it left me cold, quite the contrary — but it was more of an uplift, an inspiration.”",
      "“You see, the ruins are set in the midst of the jungle — which held them in its clutches for so many centuries that it still seems jealous of them.”",
    ],
  },
  {
    id: "unesco-sacred-dancers",
    tags: ["UNESCO", "Sacred Dance", "King Sihamoni", "Pchum Ben"],
    title: "UNESCO Announces the Sacred Dancers of Angkor US Tour",
    author: "UNESCO",
    date: "2013",
    category: "Dance & Performance",
    readTime: "6 min read",
    note: "“highly talented and spiritual”",
    image:
      "https://www.devata.org/dat-devata/uploads/2013/09/2012-02-Wat-Phou-Ritual-01-332x219.jpg.webp",
    excerpt:
      "Thirty young artists carry rare classical, folk and sacred Khmer dance across America — endorsed by King Sihamoni and UNESCO.",
    body: [
      "Hailed by H.M. King Sihamoni of Cambodia as a “highly talented and spiritual” dance troupe, thirty extraordinary young artists are embarking on the Sacred Dancers of Angkor US Tour to perform rare classical, folk and sacred Khmer dance and music.",
      "Their mission is to reconnect Cambodian-Americans with their motherland during the Holy Month of Remembrance of the Ancestors — Pchum Ben — and to raise awareness of Cambodia's endangered performing arts.",
      "The tour is endorsed and supported by King Norodom Sihamoni, the Cambodian Government and the UNESCO Office in Phnom Penh, placed under the auspices of Princess Norodom Boppha Devi — herself a celebrated former prima ballerina of the royal ballet.",
      "For the dancers, each performance is both an offering and an act of preservation: every gesture of the hand carries a vocabulary refined across a thousand years.",
    ],
  },
  {
    id: "devata-inventory",
    tags: ["Devata Inventory", "Research", "Angkor Wat", "Census"],
    title: "The Angkor Wat Devata Inventory",
    author: "Devata.org",
    date: "2013",
    category: "Research",
    readTime: "4 min read",
    note: "nearly 2,000 goddesses",
    image:
      "https://www.devata.org/dat-devata/uploads/2009/02/Angkor-Wat-Main-Map-Labeled.jpg.webp",
    excerpt:
      "The temple of Angkor Wat enshrines nearly 2,000 portraits of ancient Khmer women — documented here, one by one.",
    body: [
      "The Hindu temple of Angkor Wat enshrines nearly 2,000 portraits of ancient Khmer women, documented in the Angkor Wat Devata Inventory — the most complete census of these sacred figures ever attempted.",
      "Each devata is mapped to her exact position in the temple: her posture, headdress, jewelry and gesture carefully recorded. Together they form a vast portrait gallery of a civilization that revered the divine feminine.",
      "This living document is continually revised as new research refines our understanding of who these women were — queens, priestesses, goddesses, or perhaps all three at once.",
    ],
  },
];

export const VALUES = [
  ["Harmony", "Bridging many ethnicities and nations into one Southeast Asian whole."],
  ["Historical Access", "Opening rare texts, images and records to scholars and the public alike."],
  ["Rural Education", "Supporting learning and literacy for communities across the region."],
  ["Women's Rights", "Honoring and advancing the role of women — in history and today."],
  ["Cooperation", "Encouraging a unified community that benefits every one of its members."],
];

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1565326378721-74186198f882?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxBbmdrb3IlMjBXYXQlMjBhcHNhcmElMjBkZXZhdGElMjBzdG9uZSUyMGNhcnZpbmd8ZW58MHx8fHwxNzkxMzEyODU4fDA&ixlib=rb-4.1.0&q=85",
    caption: "Devata — east gallery",
  },
  {
    src: "https://images.unsplash.com/photo-1750850115672-b03c415db864?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxBbmdrb3IlMjBXYXQlMjBhcHNhcmElMjBkZXZhdGElMjBzdG9uZSUyMGNhcnZpbmd8ZW58MHx8fHwxNzkxMzEyODU4fDA&ixlib=rb-4.1.0&q=85",
    caption: "Crowned apsara, bas-relief",
  },
  {
    src: "https://images.unsplash.com/photo-1730440983959-8d4bf2afe5f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxDYW1ib2RpYW4lMjBjbGFzc2ljYWwlMjBraG1lciUyMGRhbmNlcnxlbnwwfHx8fDE3OTEzMTI4NTh8MA&ixlib=rb-4.1.0&q=85",
    caption: "Royal ballet, Phnom Penh",
  },
  {
    src: "https://images.unsplash.com/photo-1703521038834-06d638cb162f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxBbmdrb3IlMjBXYXQlMjBhcHNhcmElMjBkZXZhdGElMjBzdG9uZSUyMGNhcnZpbmd8ZW58MHx8fHwxNzkxMzEyODU4fDA&ixlib=rb-4.1.0&q=85",
    caption: "Paired devata, inner wall",
  },
  {
    src: "https://images.unsplash.com/photo-1602642977157-b7c8b8003afd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxjYW1ib2RpYSUyMGtobWVyJTIwdGVtcGxlJTIwYW5na29yJTIwd2F0JTIwc3VucmlzZXxlbnwwfHx8fDE3OTEzMTI3MzV8MA&ixlib=rb-4.1.0&q=85",
    caption: "Angkor Wat at dawn",
  },
];
